import { NgModule } from '@angular/core';
import { LocalBrowserStorage } from '@core/_services/local-browser.storage';

import { PowerbiEmbedService } from './powerbi-embed.service';
import { PowerbiTokenService } from './powerbi-token.service';

@NgModule({
  declarations: [],
  imports: [],
  exports: [],
  providers: [PowerbiEmbedService, LocalBrowserStorage, PowerbiTokenService],
})
export class PowerbiModule {}
